import { Space } from "antd";
import cuid from "cuid";
import PropTypes from "prop-types";
import { BiPlus } from "react-icons/bi";
import Button from "shared/components/Button";
import Select from "shared/components/Select";
import { CONDITION_OP_VALUES } from "./catalog";
import ConditionRow from "./ConditionRow";

const normalizeToList = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (value.all) return value.all;
  if (value.any) return value.any;
  return [value];
};

const FieldConditionsEditor = ({
  value,
  variables = [],
  labels = {},
  onChange,
  groupMode = "all",
}) => {
  const conditions = normalizeToList(value);

  const emit = (nextList) => {
    if (!nextList.length) {
      onChange([]);
      return;
    }
    if (groupMode === "any") onChange({ any: nextList });
    else if (groupMode === "all") onChange({ all: nextList });
    else onChange(nextList);
  };

  const updateCondition = (index, updater) =>
    emit(
      conditions.map((condition, i) =>
        i === index ? updater(condition) : condition,
      ),
    );

  return (
    <Space direction="vertical" size={12} className="canvas-editor__full-width">
      {groupMode !== "flat" ? (
        <Select
          label={labels.GROUP_MODE}
          options={[
            { value: "all", label: labels.GROUP_ALL },
            { value: "any", label: labels.GROUP_ANY },
          ]}
          value={
            value && value.any ? "any" : value && value.all ? "all" : groupMode
          }
          onChange={(mode) => {
            if (mode === "any") onChange({ any: conditions });
            else onChange({ all: conditions });
          }}
        />
      ) : null}
      {conditions.map((condition, index) => (
        <ConditionRow
          key={condition.id || index}
          condition={condition}
          index={index}
          variables={variables}
          labels={labels}
          onUpdate={(updater) => updateCondition(index, updater)}
          onRemove={() => emit(conditions.filter((_, i) => i !== index))}
        />
      ))}
      <Button
        type="primary"
        onClick={() =>
          emit([
            ...conditions,
            {
              id: cuid(),
              leftOperand: {},
              rightOperand: {},
              operation: CONDITION_OP_VALUES.IDENTITY,
            },
          ])
        }
      >
        <BiPlus size={20} /> {labels.ADD}
      </Button>
    </Space>
  );
};

FieldConditionsEditor.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  variables: PropTypes.array,
  labels: PropTypes.object,
  onChange: PropTypes.func,
  groupMode: PropTypes.oneOf(["all", "any", "flat"]),
};

FieldConditionsEditor.defaultProps = {
  value: [],
  variables: [],
  labels: {},
  onChange: undefined,
  groupMode: "all",
};

export default FieldConditionsEditor;
